import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

type TImgBlock = {
    webpImg?: string,
    pngImg?: string,
    isContain?: boolean,
}

interface ICardProps {
    isTopText?: boolean,
    isHigher?: boolean,
}

export const Card = styled.div<ICardProps>`
    flex-direction: ${p => p.isTopText ? 'column-reverse' : 'column'};
    justify-content: space-between;
    flex-wrap: nowrap;
    width: 100%;
    height: ${props => props.isHigher ? '254px' : '305px'};
    background-color: #222939;
    border-radius: ${BorderRadius.OuterBlockRadius};
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.tablet}) {
        height: ${props => props.isHigher ? '191px' : '258px'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H4};
        height: 384px;
    }
`;

export const DescriptionWrap = styled.div<{ isTopText?: boolean, isMobileImage?: boolean, isLaptopImage?: boolean }>`
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin: ${p => p.isTopText ? '32px auto auto 16px' : 'auto auto 24px 16px'};

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        margin: ${p => p.isTopText ? '39px auto auto 28px' : 'auto 16px 24px 16px'};
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin: ${p => p.isTopText
                ? '39px 16px auto 28px'
                : p.isLaptopImage
                        ? 'auto 12px 30px 16px'
                        : 'auto 12px 16px 16px'};
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin: ${p => p.isTopText ? '28px 28px auto 28px' : 'auto 16px 32px 16px'};
    }

    @media (max-width: ${wideBreakpoints.mobile}) {  
      margin: ${p => p.isTopText
                ? '39px auto auto 28px'
                : p.isMobileImage
                        ? 'auto auto 16px 28px'
                        : 'auto auto 60px 28px'};
        width: 240px;
    }
`;

export const Text = styled.div`
    max-width: 361px;
    ${FONTS.S};
    color: ${COLORS.white};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.XS};
    }
`;

export const ImageWrap = styled.div<TImgBlock>`
    border-radius: 16px;
    width: 100%;
    height: 100%;
    ${(props) => (props.pngImg || props.webpImg) && css`
    background-image: url('${useProgressiveImage(props.webpImg, { hasTimeout: true, timeoutDelay: 1 }, props.pngImg)}');
    background-repeat: no-repeat;
    background-size: ${props.isContain ? 'contain' : '100% 100%'};
`};
`;

export const Title = styled.div`
    margin-bottom: 8px;
    ${FONTS.H3};
    color: ${COLORS.white};
    max-width: 354px;

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H4};
    }
`;

export const NoSsrContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
`;

export const SRow = styled.div`
    display: flex;
    flex-wrap: nowrap;
    width: calc(100% + 32px);
    margin: 0 -16px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: calc(100% + 24px);
        margin: 0 -12px;
    }
`;

export const SCol = styled.div`
    width: 100%;
    margin: 0 16px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        margin: 12px;
    }
`;

export const ListWrap = styled.div`
    margin: 34px 0;

    & > div {
        &:first-child {
            margin-bottom: 32px;
        }
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        & > div {
            &:first-child {
                margin-bottom: 0;
            }
        }
    }
`;
